// extracted by mini-css-extract-plugin
export var container = "styles-module__container___T671d";
export var header = "styles-module__header___G3Kze";
export var imageContainer = "styles-module__imageContainer___ue1Wv";
export var image = "styles-module__image___l74w8";
export var descriptionContainer = "styles-module__descriptionContainer___ISW5r";
export var comparisonTable = "styles-module__comparisonTable___jUe8R";